import { HiMiniArrowUpCircle, HiMiniArrowDownCircle } from 'react-icons/hi2'
import { MdOutlineHourglassBottom } from 'react-icons/md'
import { FormattedMessage } from 'react-intl'
import { SalaryComparativeTranslate } from '../../../i18n/translatedMessages'

export const calcComparative = (marketValue, salary) => {
	const comparative = Math.round((salary / marketValue - 1) * 100)

	if (marketValue <= 0 || !marketValue) {
		return <MdOutlineHourglassBottom className='tw-text-purple' size={22} />
	}

	if (salary <= 0 || !salary) {
		return <span className='tw-text-purple'> -- </span>
	}

	if (comparative < 0) {
		return (
			<span>
				{comparative}% <HiMiniArrowDownCircle className='tw-text-error-600' size={18} />
			</span>
		)
	}

	if (comparative > 0) {
		return (
			<span>
				{comparative}% <HiMiniArrowUpCircle className='tw-text-green-600' size={18} />
			</span>
		)
	}

	return comparative
}

export const formatCurrency = (value, currency) => {
	try {
		if (!value || !currency) {
			return <span className='tw-text-gray-400 '> -- </span>
		}

		const cleanCurrency = currency.replace(/[^A-Z]/g, '')

		return new Intl.NumberFormat('en-US', {
			style: 'currency',
			currency: cleanCurrency,
		}).format(value)
	} catch (error) {
		console.log('ERROR formatCurrency', error)
	}
}
export const calculateSalaryDifference = (salary, salaryMarket, currency) => {
	try {
		if (salary === 0 || isNaN(salary) || !salaryMarket || !salary) {
			return <span className='tw-text-gray-400 '> -- </span>
		}

		if (!currency) {
			return Math.abs(parseInt(salaryMarket) - parseInt(salary))
		}

		return `${formatCurrency(Math.abs(parseInt(salaryMarket) - parseInt(salary)), currency)}`
	} catch {
		console.log('ERROR calculateSalaryDifference')
	}
}

export const calculateEmployeeSalary = (salary, currency) => {
	try {
		if (salary === 0 || isNaN(salary) || !salary) {
			return <span className='tw-text-gray-400 '> -- </span>
		}
		if (!currency) {
			parseInt(salary)
		}

		return `${formatCurrency(parseInt(salary), currency)}`
	} catch {
		console.log('ERROR calculateEmployeeSalary')
	}
}

export const calculatePercentageDifference = (salary, salaryMarket, currency) => {
	console.log('salary ', salary, ' salaryMarket ', salaryMarket, ' currency ', currency)
	try {
		if (salary === 0 || isNaN(salary) || !salaryMarket || !salary) {
			return SalaryComparativeTranslate.notInformed
		}

		if (!currency) {
			return `${parseInt(((salary - salaryMarket) / salaryMarket) * 100)}%`
		}

		return `${formatCurrency(parseInt(((salary - salaryMarket) / salaryMarket) * 100), currency)}%`
	} catch {
		console.log('ERROR calculatePercentageDifference')
	}
}

export const calculateCurrentQuarter = (salary, salaryMarket) => {
	if (salary === 0 || !salary) {
		return SalaryComparativeTranslate.notInformed
	}

	const percentage = ((salary - salaryMarket) / salaryMarket) * 100
	const { quarter } = getQuarterInfo(percentage)
	return getQuarterDescription(quarter)
}

export const getColorCurrentQuarter = (salary, salaryMarket) => {
	if (salary === 0 || !salary) {
		return '#64748b'
	}

	const percentage = ((salary - salaryMarket) / salaryMarket) * 100
	const { color } = getQuarterInfo(percentage)
	return color
}

export const getQuarterDescription = currentQuarter => {
	if (currentQuarter === 0) {
		return <FormattedMessage id={'belowRange'} />
	} else if (currentQuarter === 1) {
		return <FormattedMessage id={'firstQuartile'} />
	} else if (currentQuarter === 2) {
		return <FormattedMessage id={'secQuartile'} />
	} else if (currentQuarter === 3) {
		return <FormattedMessage id={'thirdQuartile'} />
	} else if (currentQuarter === 4) {
		return <FormattedMessage id={'fourthQuartile'} />
	} else if (currentQuarter === 5) {
		return <FormattedMessage id={'aboveRange'} />
	} else {
		return <FormattedMessage id={'inProcess'} />
	}
}

const getQuarterInfo = percentage => {
	if (percentage < -20) return { quarter: 0, color: '#f84228' }
	if (percentage >= -20 && percentage < -10) return { quarter: 1, color: '#f59e0b' }
	if (percentage >= -10 && percentage < 0) return { quarter: 2, color: '#f59e0b' }
	if (percentage >= 0 && percentage < 10) return { quarter: 3, color: '#41c9ff' }
	if (percentage >= 10 && percentage < 20) return { quarter: 4, color: '#25e6c4' }
	if (percentage >= 20) return { quarter: 5, color: '#f84228' }

	return { quarter: -1, color: '#d9d9f2' }
}
